import React, { useEffect, useState } from "react";
import {
  Card,
  Typography,
  Avatar,
  Box,
  Grid,
  Tabs,
  Tab,
  IconButton,
} from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import "./Teamdetails.css";
import facebook from "../../../../assets/socialmedia/facebook.svg";
import insta from "../../../../assets/socialmedia/insta.svg";
import linkedin from "../../../../assets/socialmedia/linkedin.svg";
import X from "../../../../assets/socialmedia/twiiter.svg";
import coins from "../../../../assets/socialmedia/coins.svg";
import share from "../../../../assets/profile/share.png";
import instagram1 from "../../../../assets/insta.png";
import linkedin1 from "../../../../assets/linkedin.png";
import facebook1 from "../../../../assets/facebook.png";
import twiter1 from "../../../../assets/twitter.png";
import { useParams } from "react-router-dom";
import UserService from "../../../../services/categoryService";
import PostDetails from "../../Postcards/PostDetails";
import { postDetailsByPostId } from "../../../../services/postService";
import PostMediaViewer from "./mediaListing";

const getDisplayContent = (content, index = 0) => {
  try {
    const parsed = JSON.parse(content);
    if (Array.isArray(parsed) && parsed.length > 0) {
      return parsed[index]?.content || "";
    }
  } catch (e) {
    return content;
  }
  return content;
};

const getDisplayMedia = (post, index = 0) => {
  if (!post) return [];
  let media = post?.media || [];
  try {
    const parsed = JSON.parse(post?.content);
    if (Array.isArray(parsed) && parsed.length > 1) {
      const selectedVar = parsed[index];
      if (!selectedVar) return [];
      const hasVariationId = media.some((m) => m?.variationId);
      if (hasVariationId) {
        media = media.filter((m) => m?.variationId === selectedVar?.id);
      } else {
        let offset = 0;
        for (let i = 0; i < index; i++) {
          offset +=
            (parsed[i]?.libraryMediaIds?.length || 0) +
            (parsed[i]?.mediaIds?.length || 0);
        }
        const count =
          (selectedVar?.libraryMediaIds?.length || 0) +
          (selectedVar?.mediaIds?.length || 0);
        media = count > 0 ? media.slice(offset, offset + count) : [];
      }
    }
  } catch (e) {}
  return media;
};

const ProfileCardItem = ({ post, handleDetails }) => {
  const [currentVarIndex, setCurrentVarIndex] = useState(0);

  let parsedVars = [];
  try {
    const parsed = JSON.parse(post?.content);
    if (Array.isArray(parsed)) parsedVars = parsed;
  } catch (e) {}

  const hasVariations = parsedVars.length > 1;

  const handlePrevVariation = (e) => {
    e.stopPropagation();
    setCurrentVarIndex((prev) =>
      prev === 0 ? parsedVars.length - 1 : prev - 1
    );
  };

  const handleNextVariation = (e) => {
    e.stopPropagation();
    setCurrentVarIndex((prev) =>
      prev === parsedVars.length - 1 ? 0 : prev + 1
    );
  };

  const currentMedia = getDisplayMedia(post, currentVarIndex);

  return (
    <Card
      elevation={0}
      onClick={(e) => handleDetails(post?.id, e)}
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        boxShadow: "none",
        borderRadius: "12px",
        border: "1px solid #F0F0F0",
        cursor: "pointer",
        position: "relative",
        "&:hover": { boxShadow: "0 2px 8px rgba(0,0,0,0.06)" },
      }}
    >
      {hasVariations && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#EFF6FF",
            padding: "4px 8px",
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
            borderBottom: "1px solid #E1E8F2",
          }}
        >
          <Typography
            sx={{ fontSize: "11px", color: "#0047AB", fontWeight: 600 }}
          >
            Variation {currentVarIndex + 1} of {parsedVars.length}
          </Typography>
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <IconButton
              size="small"
              onClick={handlePrevVariation}
              sx={{
                backgroundColor: "white",
                width: 20,
                height: 20,
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              }}
            >
              <ChevronLeft sx={{ fontSize: "14px" }} />
            </IconButton>
            <IconButton
              size="small"
              onClick={handleNextVariation}
              sx={{
                backgroundColor: "white",
                width: 20,
                height: 20,
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              }}
            >
              <ChevronRight sx={{ fontSize: "14px" }} />
            </IconButton>
          </Box>
        </Box>
      )}

      <Box sx={{ padding: "8px 12px 4px 12px", flex: 1 }}>
        <Typography
          color="#5D5D5D"
          fontWeight={500}
          sx={{
            fontSize: "12px",
            lineHeight: "1.4rem",
            display: "-webkit-box",
            WebkitLineClamp: currentMedia.length > 0 ? 2 : 6,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            wordBreak: "break-word",
            minHeight: currentMedia.length > 0 ? undefined : "60px",
          }}
        >
          {getDisplayContent(post?.content, currentVarIndex) ||
            post?.title ||
            ""}
        </Typography>
      </Box>
      {currentMedia.length > 0 && <PostMediaViewer media={currentMedia} />}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "6px 12px",
          borderTop: "1px solid #F5F5F5",
          mt: "auto",
        }}
      >
        <Box display="flex" alignItems="center" gap={0.6}>
          <img
            src={share}
            alt="share"
            style={{ width: "12px", height: "12px" }}
          />
          <Typography fontSize="11px" color="#5D5D5D">
            {post?.postShareData?.shareCount || 0} shares
          </Typography>
        </Box>
        <Box display="flex" gap={1} alignItems="center">
          {[
            { key: "hasInstagram", src: instagram1 },
            { key: "hasLinkedin", src: linkedin1 },
            { key: "hasFacebook", src: facebook1 },
            { key: "hasX", src: twiter1 },
          ]
            .filter((item) => post?.postShareData?.[item.key])
            .map((item, idx) => (
              <Avatar
                key={idx}
                alt={item.key}
                sx={{ width: 16, height: 16 }}
                src={item.src}
              />
            ))}
        </Box>
      </Box>
    </Card>
  );
};

const TeamDetails = () => {
  const { id } = useParams(); // <-- gets "5"
  const [tab, setTab] = useState(0);
  const [profileData, setProfileData] = useState(null);
  const [platformCount, setPlatformCount] = useState(null);
  const [posts, setPosts] = useState([]);
  const [loyaltyPoints, setLoyaltyPoints] = useState(0);
  const [postsCount, setPostsCount] = useState(0);
  const [sharesCount, setSharesCount] = useState(0);
  const [tagsCount, setTagsCount] = useState(0);
  const [postDetails, setPostDetails] = useState(false);
  const [postReviewData, setPostReviewData] = useState(null);
  const fetchProfile = async () => {
    try {
      const response = await UserService?.getProfile(id);
      if (response?.status === true) {
        setProfileData(response?.data);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };
  const fetchCounting = async () => {
    try {
      const response = await UserService.getCounting(id);
      if (response?.status === true) {
        setPlatformCount(response?.platformCountMap);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };
  const fetchLoyaltyPoints = async () => {
    try {
      const response = await UserService.getLoyaltyPoints(id);
      if (response?.status === true) {
        setLoyaltyPoints(response?.loyalty?.loyaltyPoints);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const fetchSharesCount = async () => {
    try {
      const response = await UserService.getShares(id);
      if (response?.status === true) {
        setSharesCount(response?.totalElements ?? response?.posts?.length ?? 0);
      }
    } catch (error) {}
  };
  const fetchTagsCount = async () => {
    try {
      const response = await UserService.getTags(id);
      if (response?.status === true) {
        setTagsCount(response?.totalElements ?? response?.posts?.length ?? 0);
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchProfile();
    fetchLoyaltyPoints();
    fetchCounting();
    fetchActivities();
    fetchSharesCount();
    fetchTagsCount();
  }, [id]);

  const fetchActivities = async () => {
    try {
      const response = await UserService.getActivities(id);
      if (response?.status === true) {
        setPosts(response?.posts);
        setPostsCount(response?.totalElements ?? response?.posts?.length ?? 0);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };
  const fetchShares = async () => {
    try {
      const response = await UserService.getShares(id);
      if (response?.status === true) {
        setPosts(response?.posts);
        setSharesCount(response?.totalElements ?? response?.posts?.length ?? 0);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };
  const fetchTags = async () => {
    try {
      const response = await UserService.getTags(id);
      if (response?.status === true) {
        setPosts(response?.posts);
        setTagsCount(response?.totalElements ?? response?.posts?.length ?? 0);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };
  const setupTabs = async (v) => {
    // console.log(v);
    try {
      if (v === 0) {
        setPosts([]);
        await fetchActivities();
        setTab(v);
      } else if (v === 1) {
        setPosts([]);
        await fetchShares();
        setTab(v);
      } else {
        setPosts([]);
        await fetchTags();
        setTab(v);
      }
    } catch (error) {
      console.log(error, "errors");
    }
  };
  const onClose = () => {
    setPostDetails(false);
  };
  const handleDetails = async (id, e) => {
    e.stopPropagation();
    setPostReviewData(null);
    try {
      // setLoadingPostId(id);
      const response = await postDetailsByPostId(id);
      if (response?.status === true) {
        setPostDetails(true);
        setPostReviewData(response);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      {postReviewData && postDetails && (
        <PostDetails
          open={postDetails}
          postReviewData={postReviewData}
          onClose={onClose}
        />
      )}
      <Card
        sx={{ height: "100%" }}
        elevation={0}
        className="teamsDeatail-container"
      >
        {/* Profile Section */}
        <Box className="team-member-profile">
          {/* Left - Avatar & Name */}
          <Box display="flex" alignItems="center">
            <Avatar
              sx={{
                width: 100,
                height: 100,
                bgcolor: "grey.300",
                border: "4px solid white",
              }}
              src={profileData?.profilePicture || ""}
            />
            <Box ml={2}>
              <Typography
                variant="h6"
                color="#FFFFFF"
                fontSize={"26px"}
                fontWeight="600"
              >
                {profileData?.name || ""}
              </Typography>
              <Typography
                variant="body2"
                fontWeight="400"
                fontSize={"16px"}
                color="#E7E7E7"
              >
                {[profileData?.jobTitle, profileData?.teamName].filter(Boolean).join(" | ")}
              </Typography>
            </Box>
          </Box>

          {/* Right - Coin count & Social Media Stats */}
          <Box display="flex" flexDirection="column" alignItems="flex-end">
            {/* Coin Count at the Top Right */}
            <Box display="flex" alignItems="center" mb={2}>
              <img src={coins} alt="facebook" width={23} height={23} />
              <Typography
                variant="h6"
                fontSize={"20px"}
                fontWeight="500"
                ml={1}
              >
                {loyaltyPoints || 0}
              </Typography>
            </Box>

            {/* Social Media Stats Below */}
            <Box
              display="flex"
              alignItems="center"
              gap={{ xs: 2, sm: 3, md: 2 }}
              flexWrap="wrap"
              justifyContent={{ xs: "center", md: "flex-end" }}
            >
              <Box display="flex" alignItems="center">
                <img src={facebook} alt="facebook" width={20} height={20} />
                <Typography
                  variant="body2"
                  fontSize={{ xs: "16px", sm: "18px", md: "18px" }}
                  marginLeft={1}
                >
                  {platformCount?.FACEBOOK || 0}
                </Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <img src={insta} alt="insta" width={20} height={20} />
                <Typography
                  variant="body2"
                  fontSize={{ xs: "16px", sm: "18px", md: "18px" }}
                  marginLeft={1}
                >
                  {platformCount?.INSTAGRAM || 0}
                </Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <img src={linkedin} alt="linkedin" width={20} height={20} />
                <Typography
                  variant="body2"
                  fontSize={{ xs: "16px", sm: "18px", md: "18px" }}
                  marginLeft={1}
                >
                  {platformCount?.LINKEDIN || 0}
                </Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <img src={X} alt="x" width={20} height={20} />
                <Typography
                  variant="body2"
                  fontSize={{ xs: "16px", sm: "18px", md: "18px" }}
                  marginLeft={1}
                >
                  {platformCount?.X || 0}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box>
          <Box mb={3} mt={2} width={"53%"}>
            <Tabs
              value={tab}
              onChange={(e, v) => setupTabs(v)}
              variant="fullWidth"
              TabIndicatorProps={{ style: { display: "none" } }}
              sx={{
                backgroundColor: "#F5F5F9",
                borderRadius: "50px",
                pt: 0.6,
                pb: 0.6,
                mb: 2,
                pl: 2,
                pr: 2,
                color: "#3B3B3B",
                "& .MuiTab-root": {
                  textTransform: "none",
                  color: "#3B3B3B",
                  fontWeight: 400,
                  fontSize: "14px",
                },
                "& .Mui-selected": {
                  color: "#3B3B3B !important",
                  background: "#fff",
                  fontSize: "14px",
                  borderRadius: "20px",
                  fontWeight: 600,
                },
              }}
            >
              <Tab
                sx={{
                  "&.MuiButtonBase-root": {
                    padding: "3px 6px",
                    height: "41px",
                  },
                }}
                label={
                  <Box display={"flex"} alignItems={"center"} gap={1}>
                    <div>
                      Posts&nbsp;(
                      <span style={{ color: "#2D76DC" }}>
                        {postsCount}
                      </span>
                      )
                    </div>
                  </Box>
                }
              />
              <Tab
                sx={{
                  "&.MuiButtonBase-root": {
                    padding: "3px 6px",
                    height: "41px",
                  },
                }}
                label={
                  <Box>
                    Shares&nbsp; (
                    <span style={{ color: "#2D76DC" }}>
                      {sharesCount}
                    </span>
                    )
                  </Box>
                }
              />
              <Tab
                sx={{
                  "&.MuiButtonBase-root": {
                    padding: "3px 6px",
                    height: "41px",
                  },
                }}
                label={
                  <Box>
                    Tags&nbsp; (
                    <span style={{ color: "#2D76DC" }}>
                      {tagsCount}
                    </span>
                    )
                  </Box>
                }
              />
            </Tabs>
          </Box>
        </Box>

        {/* Posts Section */}
        {tab === 0 && (
          <Box mt={3} sx={{ backgroundColor: "#F8F8FA", borderRadius: 2, p: 1.5 }}>
            <Box
              sx={{
                maxHeight: "80vh",
                overflowY: "auto",
                pr: 1,

                scrollbarWidth: "none", // Firefox
                "&::-webkit-scrollbar": { display: "none" }, // Chrome, Safari
              }}
            >
              {posts?.length !== 0 ? (
                <Grid container spacing={1}>
                  {posts?.map((post, index) => (
                    <Grid item xs={12} sm={6} md={6} lg={4} key={post?.id || index}>
                      <ProfileCardItem post={post} handleDetails={handleDetails} />
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography
                  textAlign={"center"}
                  variant="body1"
                  color="#95919D"
                >
                  No data found
                </Typography>
              )}
            </Box>
          </Box>
        )}

        {tab === 1 && (
          <Box mt={3} sx={{ backgroundColor: "#F8F8FA", borderRadius: 2, p: 1.5 }}>
            <Box
              sx={{
                maxHeight: "80vh", // or any height you need
                overflowY: "auto",
                pr: 1,

                scrollbarWidth: "none", // Firefox
                "&::-webkit-scrollbar": { display: "none" }, // Chrome, Safari
              }}
            >
              {posts?.length !== 0 ? (
                <Grid container spacing={1.2}>
                  {posts?.map((post, index) => (
                    <Grid item xs={12} sm={6} md={6} lg={4} key={post?.id || index}>
                      <ProfileCardItem post={post} handleDetails={handleDetails} />
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography
                  textAlign={"center"}
                  variant="body1"
                  color="#95919D"
                >
                  No data found
                </Typography>
              )}
            </Box>
          </Box>
        )}

        {tab === 2 && (
          <Box mt={3} sx={{ backgroundColor: "#F8F8FA", borderRadius: 2, p: 1.5 }}>
            <Box
              sx={{
                maxHeight: "80vh", // or any height you need
                overflowY: "auto",
                pr: 1,

                scrollbarWidth: "none", // Firefox
                "&::-webkit-scrollbar": { display: "none" }, // Chrome, Safari
              }}
            >
              {posts?.length !== 0 ? (
                <Grid container spacing={1.2}>
                  {posts?.map((post, index) => (
                    <Grid item xs={12} sm={6} md={6} lg={4} key={post?.id || index}>
                      <ProfileCardItem post={post} handleDetails={handleDetails} />
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography
                  textAlign={"center"}
                  variant="body1"
                  color="#95919D"
                >
                  No data found
                </Typography>
              )}
            </Box>
          </Box>
        )}
      </Card>
    </>
  );
};

export default TeamDetails;

